<template>
	<div class="paySucc">
		<div class="con">
			<i class="iconfont">&#xe655;</i>
			<p>支付成功</p>
			<a v-on:click="toRecharge"> 确定{{roomid}}</a>
		</div>
	</div>
</template>

<script>
	import cookie from '../../libs/cookie'
	export default {
		name: 'paySucc',
		data() {
			return {}
		},
		methods:{
			toRecharge(){
				location.href=location.protocol + '//h5.qxiu.com/#/recharge'+(cookie.get('roomid')?('?roomid='+cookie.get('roomid')):'')
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.paySucc {
		position: absolute;
		top: 0;
		min-width: 15rem;
		bottom: 0;
		background: #fff;
		text-align: center;
		padding-top: 4.4rem;
	}
	.con i{
		font-size: 3.84rem;
		color: green;
		border-radius: 50%;
	}
	.con p{
		font-size: 0.64rem;
		margin-top: 1rem;
	}
	.con a{
		display: inline-block;
		width: 12rem;
		height: 1.8rem;
		margin: 3.4rem auto 0;
		text-align: center;
		line-height: 1.8rem;
		color: #fff;
		font-size: 0.6rem;
		background: linear-gradient(to right,#FF7E6E,#FD2092);
		border-radius: 1rem;
	}
</style>


// WEBPACK FOOTER //
// paySucc.vue?907e3584